"use client";
import { useIntl } from "react-intl";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { useParams } from "next/navigation";
import { ICmsEnhancedTrips } from "../../../Orchestrator/Types/Interface/ICmsEnhancedTrip";
import { useEffect, useState } from "react";
import { mainAppStartupFlowExecute } from "../../../Flows/MainAppPage/MainAppStartFlow";
import { _eventBus } from "../../../core/events/EventBus";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import React from "react";
import Template4 from "../../../Components/Templates/Template4";
import Section from "../../../Components/Section/Section";
import Download from "../../../Components/Download/Download";
import "./page.css";
import { useOnLanguageChange } from "../../../Components/CustomHooks/useOnLanguageChange";
import { consumeBackPath, BACK_PATH_KEYS } from "../../../Lib/Utils/backNavigation";
import { routeTo } from "../../../Components/CustomHooks/routeChange";
import { cmsImageUrl } from "../../../Lib/Utils/cmsImage";

const EnhancedTripDetailPage = () => {
  const [enhancedTripDetails] = useRecState<ICmsEnhancedTrips[]>("enhancedTripDetailAtom");
  const intl = useIntl();
  const params = useParams();
  const slug = params.slug;
  const [initialLoadFinished, setInitialLoadFinished] = useState(false);

  useEffect(() => {
    mainAppStartupFlowExecute("EnhancedTripDetailFlow");
  }, []);

  useOnLanguageChange(() => {
    _eventBus.emit({
      eventName: evtTree.enhancedTrips.Details.Get,
      data: {
        slug,
      },
    });
  });

  useEffect(() => {
    if (slug) {
      const timer = setTimeout(() => {
        _eventBus.emit({
          eventName: evtTree.enhancedTrips.Details.Get,
          data: {
            slug,
          },
        });
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [slug]);

  const handleBack = () => {
    // router.back() is a no-op app-wide (global PreventBrowserNavigation trap),
    // so push the remembered origin (homepage or /search) instead.
    routeTo(consumeBackPath(BACK_PATH_KEYS.enhancedTrips, "/"));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoadFinished(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);


  return (

    <div>
      {!enhancedTripDetails ? (
        initialLoadFinished ? (
          <div className="text-center p-12">
            {intl.formatMessage({ id: "noData" })}
          </div>
        ) : null
      ) : (
        <Template4
          onBackClick={handleBack}
          title={enhancedTripDetails[0]?.title}
          image={cmsImageUrl(
            enhancedTripDetails[0]?.full,
            enhancedTripDetails[0]?.image
          )}
          content={enhancedTripDetails[0]?.enhance_trip_content}
        />
      )}

      <Section type="trust_builder offers_trust_builder">
        <div className="container">
          <Download />
        </div>
      </Section>
    </div>
  );
};

export default EnhancedTripDetailPage;
